import { OptionBadgeGroup } from '../components/OptionBadgeGroup';
import { TASK_ORGANIZATION_OPTIONS } from '../constants';
import type { StepProps } from '../types';
import { useTranslation } from 'react-i18next';

export function StepTaskOrganization({ answers, setAnswer }: StepProps) {
  const { t } = useTranslation('onboarding');
  const taskOrganizationOptions = TASK_ORGANIZATION_OPTIONS.map((option) => ({
    ...option,
    label: t(`taskOrganization.${option.id}`),
  }));
  return (
    <OptionBadgeGroup
      options={taskOrganizationOptions}
      selected={answers.taskOrganization}
      onChange={(val) => setAnswer('taskOrganization', val)}
    />
  );
}
